import React from 'react';
import {
    Text,
    Group,
    PopoverBase,
    usePopover,
    useBreakpoint,
    Contrast,
} from '@landr/maestro';

export const MetasPopover = ({
    metas,
    size,
    contrast,
}: {
    metas: string[];
    size: 'xs' | 'sm';
    contrast: Contrast;
}) => {
    const { getTriggerProps, getPopoverProps } = usePopover({
        hasArrow: true,
        placement: 'bottom-start',
        triggerEvent: 'hover',
    });
    const isTablet = useBreakpoint('lg');

    if (!metas.length || isTablet) {
        return null;
    }

    return (
        <>
            <Text size={size} contrast={contrast} {...getTriggerProps()}>
                {`+${metas.length}`}
            </Text>
            <PopoverBase {...getPopoverProps()} py={0} px={0}>
                <Group gutter="xxs" direction="vertical" p="xs">
                    {metas.map((meta: string) => (
                        <Group.Item key={meta}>
                            <Text size="sm" contrast="low">
                                {meta}
                            </Text>
                        </Group.Item>
                    ))}
                </Group>
            </PopoverBase>
        </>
    );
};
